import React from 'react';
import { SideBarItems } from 'components/Sidebar';
import { Archives, AssetExplorer, Collections } from 'modules/AssetManagement';
import FolderOutlined from '@mui/icons-material/FolderOutlined';
import Inventory2Outlined from '@mui/icons-material/Inventory2Outlined';
import CollectionsOutlined from '@mui/icons-material/CollectionsOutlined';
import ArchiveOutlined from '@mui/icons-material/ArchiveOutlined';

type AppMenuKey = 'campaignKing' | 'instantUpdate';

/** Asset Management accordion — same items for Campaign King and Instant Update menu keys. */
const buildAssetManagementMenu = (menuKey: AppMenuKey): SideBarItems => ({
    path: '/',
    urlKey: 'asset-management',
    text: 'Asset Management',
    icon: <FolderOutlined />,
    type: 'menuHeader',
    menuKey,
    requiredModule: 'assetsmanagement.ai',
    dictionaryKey: 'sidebar-menu-asset-management',
    items: [
        {
            path: '/asset-management/',
            urlKey: 'asset-explorer',
            text: 'Asset Explorer',
            icon: <Inventory2Outlined />,
            type: 'menuItem',
            menuKey,
            module: <AssetExplorer />,
            requiredModule: 'assetsmanagement.ai',
            dictionaryKey: 'sidebar-menu-asset-management-asset-explorer',
        },
        {
            path: '/asset-management/',
            urlKey: 'collections',
            text: 'Collections',
            icon: <CollectionsOutlined />,
            type: 'menuItem',
            menuKey,
            module: <Collections />,
            requiredModule: 'assetsmanagement.ai',
            disabled: true,
            comingSoonBadge: true,
            dictionaryKey: 'sidebar-menu-asset-management-collections',
        },
        {
            path: '/asset-management/',
            urlKey: 'archives',
            text: 'Archives',
            icon: <ArchiveOutlined />,
            type: 'menuItem',
            menuKey,
            module: <Archives />,
            requiredModule: 'assetsmanagement.ai',
            disabled: true,
            comingSoonBadge: true,
            dictionaryKey: 'sidebar-menu-asset-management-archives',
        },
    ],
});

export const ModulesMenu: SideBarItems[] = [
    buildAssetManagementMenu('campaignKing'),
    buildAssetManagementMenu('instantUpdate'),
];
